import React from 'react'

import Base from '../_Base'

const BrazilA16 = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#brazil_a16)">
      <rect width="24" height="24" rx="2" fill="#EC1D25" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.35 13.318c0-.516-.034-.85-.102-1.009a.373.373 0 0 0-.369-.232c-.176 0-.3.09-.374.266-.068.176-.108.499-.108.975v1.395c0 .516.034.85.102 1.009.068.153.193.232.374.232.176 0 .295-.085.369-.255.068-.17.108-.499.108-.986v-1.395Zm2.04-4.042v.108h-2.035v-.108c0-.516-.034-.85-.102-1.009a.373.373 0 0 0-.368-.232c-.176 0-.3.09-.374.266-.069.176-.108.505-.108.975v2.035c.176-.232.38-.408.6-.521.222-.114.483-.17.772-.17.561 0 .975.181 1.236.538.26.357.39.936.39 1.724v1.082c0 1.225-.186 2.07-.555 2.534-.368.465-1.02.698-1.956.698-.94 0-1.593-.233-1.961-.692-.369-.465-.556-1.31-.556-2.54v-3.94c0-1.224.187-2.069.556-2.528.368-.46 1.02-.692 1.961-.692.947 0 1.6.176 1.956.528.363.351.544.997.544 1.944ZM12.034 6.969h1.706v10.056h-1.944V9.548c-.17.176-.352.323-.55.454a3.42 3.42 0 0 1-.646.317V8.516c.345-.198.64-.425.884-.686.238-.26.425-.544.55-.861ZM6.954 7.07H4.981L3.598 17.1H6.36l.153-1.832h.873l.153 1.831h2.767L8.927 7.071H6.954Zm0 2.32.465 4.115h-.93l.465-4.116Z"
        fill="#fff"
      />
    </g>
    <rect x=".5" y=".5" width="23" height="23" rx="1.5" stroke="#fff" />
    <defs>
      <clipPath id="brazil_a16">
        <rect width="24" height="24" rx="2" fill="#fff" />
      </clipPath>
    </defs>
  </Base>
)

export default BrazilA16
